import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';
import { TRespondentUpdateRequest } from 'pages/Splittest/profile/model/types/profileSchema';

class ProfileModel extends Network {
  constructor(baseURL: string, timeout = 120000) {
    super(baseURL, timeout);
  }

  //GET

  async getRespondentProfile<T>(): Promise<T> {
    return this.send('get', `/respondent/profile`);
  }

  async putRespondentProfile<T>(data: TRespondentUpdateRequest): Promise<T> {
    return this.send('put', `/respondent/profile/personal`, {
      ...data,
    });
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BASE_URL as string;
const profileModel = new ProfileModel(baseUrl);
export default profileModel;
